import * as React from "react";
import {prepareUploadAdhocImage} from "../service/ImageService";
import ImageUpload from "./ImageUpload";


export default function AdhocImageUpload(props) {
    const {images, setImages} = props;

    const prepareUpload = (fileName, fileType) => {
        return prepareUploadAdhocImage(fileName, fileType);
    };

    return (
        <ImageUpload
            images={images}
            setImages={setImages}
            prepareUpload={prepareUpload}
        />
    )
}
